<section class="centro-info-section">

  <div class="centro-container">

    <!-- ===== SIDEBAR ===== -->
    <aside class="sidebar">

      <h5>PLATAFORMA DIGITALIA HISPÁNICA</h5>
      <img src="assets/home_logos/Digitalia.png" alt="Digitalia">

      <h5>E - LIBRO.</h5>
      <img src="assets/home_logos/E_LIBRO1.png" alt="E-libro">

      <h5>GALE CENGAGE LEARNING.</h5>
      <img src="assets/home_logos/cengage.jpg" alt="Cengage">

      <h5>INEGI</h5>
      <img src="assets/home_logos/INEGI.jpg" alt="INEGI">

    </aside>

    <!-- ===== CONTENIDO ===== -->
    <div class="contenido-centro">

      <h2>CENTRO DE INFORMACIÓN</h2>
      <p class="visitas">Visitas: 1072</p>

      <div class="img-centro">
        <img src="assets/servicios/ci.jpeg" alt="Centro de información">
      </div>

      <!-- MISIÓN -->
      <h4>A. Misión</h4>
      <p>
        El Centro de Información tiene como misión proporcionar servicios de información que apoyen los programas académicos de investigación y a la formación integral de profesionistas competitivos...
      </p>

      <ul>
        <li>Desarrollar, organizar y promover los recursos en todos los medios.</li>
        <li>Orientar a la comunidad tecnológica en el uso adecuado de la información.</li>
        <li>Mantener una comunicación fluida con los usuarios.</li>
      </ul>

      <!-- VISIÓN -->
      <h4>B. Visión</h4>
      <p>
        Servir de unidad de apoyo a la docencia y la investigación para satisfacer necesidades educativas...
      </p>

      <!-- VALORES -->
      <h4>C. Valores</h4>
      <p><strong>Calidad de servicio:</strong> Brindar un servicio de calidad.</p>
      <p><strong>Actitud de servicio:</strong> Apoyar el desarrollo con esfuerzo.</p>
      <p><strong>Trabajo en equipo:</strong> Motivación grupal.</p>
      <p><strong>Confiabilidad:</strong> Honestidad e integridad.</p>

      <!-- OBJETIVO -->
      <h4>D. Objetivo</h4>
      <p>
        Proporcionar y promover el uso efectivo de fuentes de información bibliográfica...
      </p>

      <!-- INFO FINAL -->
      <div class="info-final">

        <div>
          <h5>HORARIOS DE ATENCIÓN</h5>
          <p>Lunes a Viernes</p>
          <p class="horario">8:00 - 16:00 HRS</p>
        </div>

        <div>
          <h5>PERSONAL DE ATENCIÓN</h5>
          <p><strong>Mtra. Roberta Magaña Benítez</strong></p>
          <p>Responsable del área</p>

          <p><strong>José Armando Sánchez Tamay</strong></p>
          <p>Auxiliar</p>
        </div>

        <div>
          <h5>CONTACTO</h5>
          <p>
            <a href="mailto:biblioteca@itsescarcega.edu.mx">
              biblioteca@itsescarcega.edu.mx
            </a>
          </p>
        </div>

      </div>

      <!-- LINKS -->
      <div class="links-final">
        <a href="#">1.- Reglamento Centro de Información</a>
        <a href="#">2.- Procedimiento de Préstamo</a>
      </div>

    </div>

  </div>

</section>